import { type NetlifySDK } from "@netlify/sdk--ui-core";
import { useContext } from "react";
import { NetlifySDKContext } from "./NetlifySDKProvider.jsx";

export const useNetlifySDK = (): NetlifySDK => {
  const { sdk } = useContext(NetlifySDKContext);

  if (sdk === null) {
    throw new Error(
      "The Netlify SDK is not loaded. Make sure you're calling `useNetlifySDK` from within a `NetlifySDKProvider`.",
    );
  }

  return sdk;
};
